import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Space, Spin, Grid, App } from "antd";
import { ArrowLeftOutlined, PrinterOutlined, FilePdfOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { getCreditorPayWithDetailsApi } from "../../apiservice/accounts";
import { generatePdfBlob } from "../../lib/functions";
import ReportDom from "../../components/common/ReportDom";
import SupplierPaymentVoucherBody from "./components/SupplierPaymentVoucherBody";

const SupplierPaymentVoucher = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const reportRef = useRef(null);
  const viewRef = useRef(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: `Payment Voucher - ${data?.pay_code || ""}`,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getCreditorPayWithDetailsApi({ pay_id: id })
      .then((res) => {
        if (res?.data?.length) setData(res.data[0]);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleDownload = async () => {
    if (!viewRef.current) return;
    try {
      setPdfLoading(true);
      const blob = await generatePdfBlob(viewRef.current);
      if (!blob) throw new Error("PDF generation failed");

      const fileName = `Payment_${data?.pay_code || id}.pdf`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      message.error("Failed to download voucher");
    } finally {
      setPdfLoading(false);
    }
  };

  return (
    <div className="p-4">
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          {!screens.xs && "Back"}
        </Button>

        <Space>
          <Button
            type="primary"
            icon={<FilePdfOutlined />}
            loading={pdfLoading}
            onClick={handleDownload}
            disabled={!data}
          >
            {!screens.xs && "Download"}
          </Button>
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            disabled={!data}
          >
            {!screens.xs && "Print"}
          </Button>
        </Space>
      </div>

      <Card className="shadow-md rounded-xl">
        <div ref={viewRef} style={{ width: "fit-content" }}>
          {loading ? <Spin /> : data ? <SupplierPaymentVoucherBody data={data} /> : null}
        </div>
      </Card>

      {/* PRINT */}
      {data && (
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            mode="receipt-voucher"
            renderTable={() => (
              <SupplierPaymentVoucherBody data={data} printMode />
            )}
          />
        </div>
      )}
    </div>
  );
};

export default SupplierPaymentVoucher;
